import { createFileRoute } from '@tanstack/react-router';
import { t } from 'utils/routeTitle';

import PHPMyAdmin from 'component/view/Redirects/PHPMyAdmin';

import { requireActivePlan } from './-guards';

export const Route = createFileRoute('/n/_auth/manage/$siteId/phpmyadmin')({
  staticData: { routeTitle: t('common.wordpress_management') },
  beforeLoad: requireActivePlan,
  component: PHPMyAdmin,
});
